import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import ButtonsCenter from '@/pages/home/hero/thailand/ButtonsCenter';

const ControlsCenter = () => {
  const intl = useIntl();

  return (
    <div className="flex flex-col gap-8 items-center text-white">
      <div className="flex flex-col items-center gap-2 sm:gap-4 justify-center">
        <div className="text-2xl sm:text-5xl px-6 font-bold font-display text-center">
          <FormattedMessage
            id="hero.loggedIn.header"
            values={{
              a: str => <span className="text-blue-light">{str}</span>,
            }}
          />
        </div>
        <div className="text-lg sm:text-xl">{intl.formatMessage({ id: 'hero.loggedIn.text' })}</div>
      </div>
      <ButtonsCenter />
    </div>
  );
};

export default ControlsCenter;
